import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新增兑换 ")
const _hoisted_4 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "商品"),
    /*#__PURE__*/_createElementVNode("th", null, "回收价"),
    /*#__PURE__*/_createElementVNode("th", null, "赏品类型"),
    /*#__PURE__*/_createElementVNode("th", null, "兑换点数"),
    /*#__PURE__*/_createElementVNode("th", null, "兑换限制"),
    /*#__PURE__*/_createElementVNode("th", null, "库存")
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 上移 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 下移 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_NewEventItemModal = _resolveComponent("NewEventItemModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.event,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "名称",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.event.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.event.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "启用" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.event.enabled,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.event.enabled) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_2,
          _createVNode(_component_el_form_item, { label: "活动兑换列表" }, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "button",
                status: "primary",
                "data-bs-toggle": "modal",
                "data-bs-target": "#kt_modal_new_box_item_info"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("table", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedEventItems(), (item) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  (item._destroy != 1)
                    ? (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.brand) + " - " + _toDisplayString(item.product), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatPrice(item.recycle_price)), 1),
                        _createElementVNode("td", null, _toDisplayString(item.is_point ? '点数' : '商品'), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_input_number, {
                            modelValue: item.point,
                            "onUpdate:modelValue": ($event: any) => ((item.point) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_input_number, {
                            modelValue: item.limit_quantity,
                            "onUpdate:modelValue": ($event: any) => ((item.limit_quantity) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_el_input_number, {
                            modelValue: item.stock,
                            "onUpdate:modelValue": ($event: any) => ((item.stock) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("td", null, [
                          _createVNode(_component_vxe_button, {
                            type: "button",
                            status: "primary",
                            onClick: ($event: any) => (_ctx.move_up(item))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_vxe_button, {
                            type: "button",
                            status: "primary",
                            onClick: ($event: any) => (_ctx.move_down(item))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_vxe_button, {
                            type: "button",
                            status: "primary",
                            onClick: ($event: any) => (_ctx.destroy_item(item))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _hoisted_9,
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              (_ctx.current_role === 'admin' || !_ctx.event.enabled)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _createVNode(_component_NewEventItemModal, { add_box_item_infos: _ctx.add_event_items }, null, 8, ["add_box_item_infos"])
  ], 64))
}